import { Row, Col, Container, Button, Card } from "react-bootstrap";
import MainNav from "../Global/MainNav";
import Footer from "../Global/Footer";
import Image from "react-bootstrap/Image";
import logo from "../../images/threadvis-logo.png";

const About = () => {
  return (
    <section
      id="about"
      className="home_about mt-5 d-flex align-items-center position-relative"
    >
      <div className="overlay"></div>
      <Image className="home_about_accent_img" />
      <Container className="my-5">
        <Row className=" align-items-center">
          <Col
            sm="12"
            lg="6"
          >
            <Image
              fluid
              width="550rem"
              src={logo}
            />
          </Col>
          <Col
            sm="12"
            lg="6"
            className="text-center text-lg-left"
          >
            <h6 className="text-primary fs-6 fw-semibold">Cheyenne Threadgill</h6>
            <h4 className="fw-semibold fw-bold">About Me</h4>
            <p>
              With experience in graphic design and web design, coupled with recent training and hands-on experience in
              web development technologies such as HTML, CSS, JavaScript, React.js, Node.js, and MySQL, I am eager to
              pivot my career into a role where I can contribute my technical and creative skills to a dynamic team and
              leverage my creative and technical abilities to develop impactful web applications.
              <br></br>
              <br></br>
              My creative and inquisitive nature allow me to create aesthetically pleasing visual and user experiences.
              Knowing I've built something that others could appreciate and inherit for their own brands and clients is
              what drives me the most!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
